import React from 'react';
import '../styles/nav.css';
import PDF from '../Documents/resume.pdf';

function Nav() {
    return (
        <div className="nav__wrapper">
            <a href="#header">
                <div className="nav__button">
                    Header
                </div>
            </a>

            <a href="#about">
                <div className="nav__button">
                    About
                </div>
            </a>

            <a href="#projects">
                <div className="nav__button">
                    Projects
                </div>
            </a>

            <a href="#contact">
                <div className="nav__button">
                    Contact
                </div>
            </a>

            <a href={PDF}>
                <div className="nav__button">
                    Resume
                </div>
            </a>
        </div>
    )
}

export default Nav
